import messages from "./messages";

export const resetPasswordPageConfig = [
  {
    id: "password",
    label: messages.currentPassword,
  },
  {
    id: "newPassword",
    label: messages.newPassword,
  },
  {
    id: "confirmPassword",
    label: messages.confirmPassword,
  },
];
